import React from 'react'
import { BiSearch } from 'react-icons/bi'
import { InputGroup, Button } from '../'
import Container from './styles'

const SearchBar = ({
  placeholder,
  loading,
  handleSearch,
  onChange,
  className,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    if (typeof handleSearch === 'function') {
      handleSearch()
    }
  }

  return (
    <Container className={`searchBar--container ${className ? className : ''}`}>
      <form onSubmit={handleSubmit}>
        <BiSearch />
        <InputGroup
          type="search"
          onChange={onChange}
          placeholder={placeholder}
        />
        <Button loading={loading} type="submit">
          Search
        </Button>
      </form>
    </Container>
  )
}

export default SearchBar
